import { VSP_SURVEY_SOURCE_LIST, VSP_SURVEY_SOURCE_LIST_ERROR, VSP_SURVEY_SOURCE_LIST_SUCCESS, VSP_SURVEY_SOURCE_UPDATE_DATA } from './constants';

export default function vspSurveySourceReducer(state, action) {
	switch (action.type) {
	case VSP_SURVEY_SOURCE_LIST :
		return { ...state, loading : true, error : false };
	case VSP_SURVEY_SOURCE_LIST_SUCCESS :
		return { ...state,vspSurveySource : action.payload, loading : false, error : false};
	case VSP_SURVEY_SOURCE_LIST_ERROR : 
		return { ...state, loading : false, error : true };
	case VSP_SURVEY_SOURCE_UPDATE_DATA :
		return { ...state, updateData : action.payload };
	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}